import 'jquery/dist/jquery';

import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/util';

import 'imagelightbox/src/imagelightbox';

import './js/scroll-to-top';


$( function()
{
    $( '.imagelightbox-active section a' ).imageLightbox(
        {

            animationSpeed: 150,                     // integer;
            activity:       true,                   // bool;            show activity indicator
            arrows:         true,                   // bool;            show left/right arrows
            caption:        true,                   // bool;            show captions
            preloadNext:    false,
            overlay:        false
        }
    );
});
